import React from "react";
import CreateEditCategory from "../../components/manager/CreateEdit/CreateEditCategory";

function CategoryAddPage() {
    return (
        <div className='pageContianer'>
            <CreateEditCategory typePage='CREATE'/>
        </div>
    );
}
export default CategoryAddPage;